import _ from 'lodash-es';
import angular from 'angular';
import PortainerError from 'ShbDeployer/error';
import KubernetesEventConverter from 'Kubernetes/converters/event';

class KubernetesEventService {
  /* @ngInject */
  constructor($async, KubernetesEvents) {
    this.$async = $async;
    this.KubernetesEvents = KubernetesEvents;

    this.getAllAsync = this.getAllAsync.bind(this);
  }

  /**
   * GET
   */
  async getAllAsync(namespace) {
    try {
      const data = await this.KubernetesEvents(namespace).get().$promise;
      const res = _.map(data.items, (item) => KubernetesEventConverter.apiToEvent(item));
      return res;
    } catch (err) {
      throw new PortainerError('Не удалось получить события', err);
    }
  }

  get(namespace) {
    return this.$async(this.getAllAsync, namespace);
  }
}

export default KubernetesEventService;
angular.module('shbdeployer.kubernetes').service('KubernetesEventService', KubernetesEventService);
